export class Storage {
  static STORAGE_KEY = 'lesnikuv_ucen'
  static BACKUP_KEY = 'lesnikuv_ucen_backup'

  static set(value: any): void {
    window.localStorage.setItem(Storage.STORAGE_KEY, JSON.stringify(value))
  }

  static get(): any {
    const str: string | null = window.localStorage.getItem(Storage.STORAGE_KEY)
    if (!str) {
      return null
    }
    try {
      return JSON.parse(str)
    } catch (e) {
      console.warn(e)
    }
  }

  static remove(): void {
    window.localStorage.removeItem(Storage.STORAGE_KEY)
  }

  static setBackup(username: string, value: any): void {
    let nextBackup = Storage.getBackup()
    if (!nextBackup) {
      nextBackup = { [username]: value }
    } else {
      nextBackup[username] = value
    }
    window.localStorage.setItem(Storage.BACKUP_KEY, JSON.stringify(nextBackup))
  }

  static getBackup(username?: string): any {
    const str: string | null = window.localStorage.getItem(Storage.BACKUP_KEY)
    if (!str) {
      return null
    }
    try {
      const res = JSON.parse(str)
      if (username?.length) {
        return res[username]
      }
      return res
    } catch (e) {
      console.warn(e)
    }
  }

  static removeBackup(): void {
    window.localStorage.removeItem(Storage.BACKUP_KEY)
  }

  static clear(): void {
    window.localStorage.clear()
  }
}
